/**
 * Determine the currently selected cushion shape.
 *
 * Reads the shape radio group in the DOM and returns a normalized string
 * identifier for the active shape. Only one shape can be selected at a time.
 *
 * Shapes returned:
 * - "square_rectangle"
 * - "trapezoid"
 * - "round"
 *
 * Defaults to "square_rectangle" if no option is selected.
 *
 * @returns {('square_rectangle'|'trapezoid'|'round')} Normalized shape id
 */
function getCushionShape() {
    // Check shapes, return the shape name of the appropriate selection. can only return a single value
    // is square_rectangle shape
    let squareCheck = (document.querySelector('._cd--shape input[data-cd-option-name="cd--shape-square"]:checked') !== null);
    // is trapezoid
    let trapezoidCheck = (document.querySelector('._cd--shape input[data-cd-option-name="cd--shape-trapezoid"]:checked') !== null);
    // is round shape
    let roundCheck = (document.querySelector('._cd--shape input[data-cd-option-name="cd--shape-round"]:checked') !== null);
    
    if(squareCheck){
        return "square_rectangle";
    }else if(trapezoidCheck){
        return "trapezoid";
    }else if(roundCheck){
        return "round";
    }else{
        return "square_rectangle";
    }            
}

/**
 * Determine the currently selected fabric selection.
 *
 * Reads the fabric selection radio group in the DOM and returns a normalized string
 * identifier for the active shape. Only one fabric selection can be selected at a time.
 *
 * Fabric selections returned:
 * - "standard"
 * - "waterproof"
 * - "com"
 *
 * Defaults to "standard" if no option is selected.
 *
 * @returns {('standard'|'waterproof'|'com')} Normalized standard fabric id
 */
function getFabricSelection() {
    // Check fabric selection, return the name of the appropriate selection. can only return a single value
    // is standard fabric selection
    let standardCheck = (document.querySelector('._cd--shape input[data-cd-option-name="cd--fabric-selection-standard"]:checked') !== null);
    // is rain fabric selection
    let waterproofCheck = (document.querySelector('._cd--shape input[data-cd-option-name="cd--fabric-selection-sunbrella-rain"]:checked') !== null);
    // is com fabric selection
    let comCheck = (document.querySelector('._cd--shape input[data-cd-option-name="cd--fabric-selection-com"]:checked') !== null);

    if (standardCheck){
        return "standard";
    }else if(waterproofCheck){
        return "waterproof";
    }else if (comCheck){
        return "com";
    }else{
        return "standard";
    }
}

////////////////////////////////////////////////////////////
/* added check for COM fabric inputs */
////////////////////////////////////////////////////////////
var comFabricWidth = "";
var comFabricDesign = "";
var comFabricDesignLabelName = "";
if(this.getFabricSelection() == "com"){

  comFabricWidth = document.querySelector('._cd--com-fabric-width input[data-cd-option-name="cd--com-fabric-width"]').value;
  comFabricDesignLabelName = document.querySelector('._cd--com-fabric-design input:checked').dataset.optionLabel;
  if(comFabricDesignLabelName == "Is Solid"){
    comFabricDesign = "Is Solid";
  } else if(comFabricDesignLabelName == "Is Patterned"){
    comFabricDesign = "Is Patterned";
  } else if(comFabricDesignLabelName == "Is Striped"){
    comFabricDesign =  "Is Striped";
  } /* else if(comFabricDesignLabelName == "Is Plaid"){
    comFabricDesign = "Is Plaid";
  } */
}

////////////////////////////////////////////////////////////
/* added check for COM fabric inputs */
////////////////////////////////////////////////////////////
var comWeltFabricWidth = "";
var comWeltFabricDesign = "";
var comWeltFabricDesignLabelName = "";
if(this.getFabricSelection() == "com" && document.querySelector('._cd--welt input[data-cd-option-name="cd--welt-double"]:checked') !== null){

  comWeltFabricWidth = document.querySelector('._cd--com-fabric-width input[data-cd-option-name="cd--com-welt-width"]').value;
  comWeltFabricDesignLabelName = document.querySelector('._cd--com-fabric-design input:checked').dataset.optionLabel;
  if(comWeltFabricDesignLabelName == "Is Solid"){
    comWeltFabricDesign = "Is Solid";
  } else if(comWeltFabricDesignLabelName == "Is Patterned"){
    comWeltFabricDesign = "Is Patterned";
  } else if(comWeltFabricDesignLabelName == "Is Striped"){
    comWeltFabricDesign =  "Is Striped";
  } /* else if(comWeltFabricDesignLabelName == "Is Plaid"){
    comWeltFabricDesign = "Is Plaid";
  } */
}

//////////////////////////////
// Tessellation helpers and packer
//////////////////////////////

function polygonRotate180(poly, width, height) {
    const cx = width / 2, cy = height / 2;
    return poly.map(p => ({ x: (2 * cx - p.x), y: (2 * cy - p.y) }));
}

function polygonAABB(poly){
    let minX=Infinity, minY=Infinity, maxX=-Infinity, maxY=-Infinity;
    for(const p of poly){
        if (p.x < minX) minX = p.x;
        if (p.y < minY) minY = p.y;
        if (p.x > maxX) maxX = p.x;
        if (p.y > maxY) maxY = p.y;
    }
    return {minX, minY, maxX, maxY, width:(maxX-minX), height:(maxY-minY)};
}

function translatePoly(poly, dx, dy){
    return poly.map(p => ({x: p.x + dx, y: p.y + dy}));
}

// SAT for convex polygons with kerf spacing. Returns true if polygons overlap (considering kerf as required gap).
function polygonsOverlapSAT(a, b, kerf){
    function getAxes(poly){
        const axes=[]; const n=poly.length;
        for(let i=0;i<n;i++){
            const p1=poly[i]; const p2=poly[(i+1)%n];
            const edgeX=p2.x-p1.x, edgeY=p2.y-p1.y;
            const nx=-edgeY, ny=edgeX; // normal
            const len=Math.hypot(nx, ny) || 1;
            axes.push({x:nx/len, y:ny/len});
        }
        return axes;
    }
    function project(poly, axis){
        let min=Infinity, max=-Infinity;
        for(const p of poly){
            const proj=p.x*axis.x + p.y*axis.y;
            if (proj < min) min = proj;
            if (proj > max) max = proj;
        }
        return {min,max};
    }
    const axes=[...getAxes(a), ...getAxes(b)];
    const spacing = kerf || 0;
    for(const axis of axes){
        const pa=project(a,axis); const pb=project(b,axis);
        if (pa.max + spacing <= pb.min || pb.max + spacing <= pa.min) {
            return false; // separated along this axis (with spacing)
        }
    }
    return true; // no separating axis => overlap (too close)
}

/**
 * Tessellate faces across fabric width with 0/180° rotations.
 * Greedy row placement with SAT collision checks and kerf spacing.
 *
 * Faces wider than fabricWidth are handled per standard upholstery practice:
 * - If rotationAllowed and the face's height fits within fabricWidth, rotate 90°
 *   (railroading) so the shorter dimension spans the bolt width.
 * - If neither dimension fits, the face requires multiple widths of fabric that
 *   are seamed together. Yardage is calculated as ceil(width/fabricWidth) * height
 *   linear inches, matching how upholstery calculators account for wide pieces.
 *
 * @param {Array<{name:string,count:number,polygon:Array<{x:number,y:number}>,rotationAllowed:boolean,kerf:number}>} faceDefs
 * @param {number} fabricWidth
 * @returns {{placements:Array<{name:string,poly:Array<{x:number,y:number}>}>, usedInches:number}}
 */
function tessellateFaces(faceDefs, fabricWidth) {
    // Expand counts
    const instances=[];
    for(const fd of faceDefs){
        const basePoly = Array.isArray(fd.polygon) ? fd.polygon : [];
        if (!basePoly.length) continue;
        const bb = polygonAABB(basePoly);
        for(let i=0;i<fd.count;i++){
            instances.push({ name: fd.name, basePoly, bb, rotationAllowed: !!fd.rotationAllowed, kerf: fd.kerf || 0 });
        }
    }
    // Sort tallest-first (by bounding-box height)
    instances.sort((a,b)=> (b.bb.height - a.bb.height));

    const placements=[];
    let cursorY=0; let rowHeight=0; let rowPolys=[];
    let extraInches = 0; // accumulates yardage for faces requiring multiple widths (seaming)

    for(const inst of instances){
        const kerf = inst.kerf || 0;
        const variants = [inst.basePoly];
        if (inst.rotationAllowed) {
            variants.push(polygonRotate180(inst.basePoly, inst.bb.width, inst.bb.height));
        }

        let placed=false;
        for(const variant of variants){
            const vbb = polygonAABB(variant);
            let x=0; const y=cursorY;
            while (true){
                if (x + vbb.width > fabricWidth) break;
                const poly = translatePoly(variant, x - vbb.minX, y - vbb.minY);
                let collide=false;
                for(const rp of rowPolys){
                    if (polygonsOverlapSAT(poly, rp.poly, kerf)) { collide=true; break; }
                }
                if (!collide){
                    placements.push({ name: inst.name, poly });
                    rowPolys.push({ poly });
                    const placedBB = polygonAABB(poly);
                    rowHeight = Math.max(rowHeight, placedBB.maxY - y);
                    placed=true; break;
                }
                x += Math.max(kerf, 0.25);
            }
            if (placed) break;
        }
        if (!placed){
            // start new row
            cursorY += rowHeight + (instances[0]?.kerf || 0);
            rowHeight = 0; rowPolys = [];
            // place at row start
            const variants2 = [inst.basePoly];
            if (inst.rotationAllowed) {
                variants2.push(polygonRotate180(inst.basePoly, inst.bb.width, inst.bb.height));
            }
            for(const v of variants2){
                const bb2 = polygonAABB(v);
                if (bb2.width > fabricWidth) continue;
                const poly = translatePoly(v, -bb2.minX, cursorY - bb2.minY);
                placements.push({ name: inst.name, poly });
                rowPolys.push({ poly });
                const placedBB2 = polygonAABB(poly);
                rowHeight = Math.max(rowHeight, placedBB2.maxY - cursorY);
                placed=true; break;
            }
            if (!placed && inst.rotationAllowed && inst.bb.height <= fabricWidth){
                // Railroading: rotate 90° so the shorter dimension (height) spans the bolt width
                const railPoly = inst.basePoly.map(p => ({ x: p.y, y: p.x }));
                const railBB = polygonAABB(railPoly);
                if (railBB.width <= fabricWidth){
                    const poly = translatePoly(railPoly, -railBB.minX, cursorY - railBB.minY);
                    placements.push({ name: inst.name + ' (railroaded)', poly });
                    rowPolys.push({ poly });
                    const placedBB3 = polygonAABB(poly);
                    rowHeight = Math.max(rowHeight, placedBB3.maxY - cursorY);
                    placed=true;
                }
            }
            if (!placed){
                // Face is wider than fabricWidth in both orientations; requires multiple widths (seaming)
                // Standard upholstery practice: ceil(faceWidth / fabricWidth) widths, each consuming faceHeight linear inches
                const numWidths = Math.ceil(inst.bb.width / fabricWidth);
                const seamInches = numWidths * (inst.bb.height + kerf);
                extraInches += seamInches;
                //if(window.console){ console.log('tessellateFaces: face "' + inst.name + '" (' + inst.bb.width.toFixed(1) + '" x ' + inst.bb.height.toFixed(1) + '") exceeds fabric width (' + fabricWidth + '"); requires ' + numWidths + ' widths (' + seamInches.toFixed(1) + '" linear) with seaming'); }
            }
        }
    }
    const usedInches = cursorY + rowHeight + extraInches;
    return { placements, usedInches };
}

/**
 * Compute tessellated totals for main and welt fabrics.
 * Returns { main: { inches, yards }, welt: { inches, yards }, facesPlacements }
 */
function computeTessellatedTotals(items, quantity, mainFabricWidthInches, weltFabricWidthInches){
    const q = Math.max(0, parseInt(quantity || 0, 10));
    if (!Array.isArray(items) || !q) { return { main:{inches:0,yards:0}, welt:{inches:0,yards:0}, facesPlacements: [] }; }
    const prep = buildPackingPreparation(items, q);
    //console.log('=== CUT PIECES (buildPackingPreparation) ===');
    //console.log('FACES:');
    prep.faces.forEach(function(f){ 
      //console.log('  ' + f.name + ' [' + f.source + ']: ' + f.width + '" x ' + f.length + '"  x' + f.count + '  (fabric: ' + f.fabricName + ')  rotationAllowed=' + f.rotationAllowed); 
    });
    //console.log('STRIPS:');
    prep.strips.forEach(function(s){ 
      //console.log('  ' + s.name + ' [' + s.source + ']: stripHeight=' + s.stripHeight + '"  totalLinear=' + s.totalLinear + '"  x' + s.count + '  (fabric: ' + s.fabricName + ')'); 
    });
    //console.log('=== END CUT PIECES ===');
    // Group faces by fabricName (typically one group for main fabric)
    const facesByFabric = {};
    for (const f of prep.faces){
        const key = f.fabricName || 'main';
        if (!facesByFabric[key]) facesByFabric[key] = [];
        facesByFabric[key].push(f);
    }

    // Compute face inches across all fabric groups (non-welt)
    let mainFacesInches = 0; let facesPlacements = [];
    if (facesByFabric && Object.keys(facesByFabric).length){
        const fabricWidth = parseFloat(mainFabricWidthInches||0);
        for (const key of Object.keys(facesByFabric)){
            const { placements, usedInches } = tessellateFaces(facesByFabric[key], fabricWidth);
            mainFacesInches += usedInches;
            facesPlacements = facesPlacements.concat(placements);
        }
    }

    // Strips: compute inches per fabricName
    let mainStripsInches = 0;
    let weltStripsInches = 0;
    for (const s of prep.strips){
        const width = (s.name === 'Welt') ? parseFloat(weltFabricWidthInches||0) : parseFloat(mainFabricWidthInches||0);
        if (!width) { continue; }
        const passes = Math.ceil((s.totalLinear || 0) / width);
        const inches = passes * (parseFloat(s.stripHeight||0) + CONFIG.spacingBetweenPatterns);
        if (s.name === 'Welt') { weltStripsInches += inches; } else { mainStripsInches += inches; }
    }

    const mainInches = mainFacesInches + mainStripsInches;
    const weltInches = weltStripsInches;
    const mainYards = mainInches / 36;
    const weltYards = weltInches / 36;
    return { main:{ inches: mainInches, yards: mainYards }, welt:{ inches: weltInches, yards: weltYards }, facesPlacements };
}

/**
 * Build a convex polygon footprint for a face piece based on item shape and dimensions.
 * Coordinates are in inches, origin at (0,0), y grows along bolt length.
 * - square_rectangle: rectangle w x l
 * - square_back: rectangle w x h
 * - trapezoid seat: top = frontWidth, bottom = rearWidth, height = depth
 * - trapezoid back: top = upperWidth, bottom = lowerWidth, height = height
 * - round: N-gon approximation of circle (diameter)
 * Returns array of {x,y} in clockwise order.
 * @param {{type:string,shape:string,dimensions:Object}} item
 * @param {number} [nSides=24] Number of sides for round approximation
 */
function buildFacePolygon(item, nSides = 24) {
    const s = item.shape;
    const d = item.dimensions || {};
    const pts = [];
    if (s === 'square_rectangle') {
        if (item.type === 'seat') {
            const w = parseFloat(d.width || 0);
            const l = parseFloat(d.depth || 0);
            pts.push({x:0,y:0},{x:w,y:0},{x:w,y:l},{x:0,y:l});
            return pts;
        } else {
            const w = parseFloat(d.width || 0);
            const h = parseFloat(d.height || 0);
            pts.push({x:0,y:0},{x:w,y:0},{x:w,y:h},{x:0,y:h});
            return pts;
        }
    } else if (s === 'trapezoid') {
        if (item.type === 'seat') {
            const f = parseFloat(d.frontWidth || 0);
            const r = parseFloat(d.rearWidth || 0);
            const h = parseFloat(d.depth || 0);
            const wMax = Math.max(f, r);
            const tL = (wMax - f) / 2;
            const bL = (wMax - r) / 2;
            pts.push(
                {x:tL, y:0},
                {x:tL + f, y:0},
                {x:bL + r, y:h},
                {x:bL, y:h}
            );
            return pts;
        } else {
            const u = parseFloat(d.upperWidth || 0);
            const lwr = parseFloat(d.lowerWidth || 0);
            const h = parseFloat(d.height || 0);
            const wMax = Math.max(u, lwr);
            const tL = (wMax - u) / 2;
            const bL = (wMax - lwr) / 2;
            pts.push(
                {x:tL, y:0},
                {x:tL + u, y:0},
                {x:bL + lwr, y:h},
                {x:bL, y:h}
            );
            return pts;
        }
    } else if (s === 'round') {
        const dia = parseFloat(d.diameter || 0);
        const r = dia / 2;
        // Circle centered at (r, r)
        for (let i=0;i<nSides;i++){
            const theta = (2*Math.PI*i)/nSides;
            pts.push({x: r + r*Math.cos(theta), y: r + r*Math.sin(theta)});
        }
        return pts;
    }
    return pts;
}

/**
 * Compute welt perimeter for a cushion/back, matching builderManufacturing.php.
 *
 * Welt runs around both faces (top + bottom), so the single-face perimeter is doubled.
 * Additional allowance is added per shape:
 * - square_rectangle: ((w*2 + h*2) * 2) + 10  [+10" allowance, ×2 for two faces]
 * - trapezoid: ((upperW + lowerW + height + exteriorHeight) * 2) + 10  [uses slant height, ×2, +10"]
 * - round: ((diameter * pi) * 2) * 1.2  [×2 for two faces, ×1.2 = 20% extra]
 *
 * @param {{type:string,shape:string,dimensions:Object}} item
 * @returns {number}
 */
function getItemPerimeter(item) {
    const s = item.shape;
    const d = item.dimensions || {};
    if (s === 'square_rectangle') {
        if (item.type === 'seat') {
            const w = parseFloat(d.width || 0);
            const l = parseFloat(d.depth || 0);
            // PHP: ((w*2 + l*2) * 2) + 10 — doubled for two faces, +10" allowance
            return (((w * 2) + (l * 2)) * 2) + 10;
        } else {
            const w = parseFloat(d.width || 0);
            const h = parseFloat(d.height || 0);
            return (((w * 2) + (h * 2)) * 2) + 10;
        }
    } else if (s === 'trapezoid') {
        let upperW, lowerW, height;
        if (item.type === 'seat') {
            upperW = parseFloat(d.frontWidth || 0);
            lowerW = parseFloat(d.rearWidth || 0);
            height = parseFloat(d.depth || 0);
        } else {
            upperW = parseFloat(d.upperWidth || 0);
            lowerW = parseFloat(d.lowerWidth || 0);
            height = parseFloat(d.height || 0);
        }
        // Compute exteriorHeight (slant height) when widths differ
        // PHP: sqrt(height^2 + (upperWidth - lowerWidth)^2)
        let exteriorHeight = height;
        if (upperW !== lowerW) {
            exteriorHeight = Math.sqrt(Math.pow(height, 2) + Math.pow(Math.abs(upperW - lowerW), 2));
        }
        // PHP: ((upperW + lowerW + height + exteriorHeight) * 2) + 10
        return ((upperW + lowerW + height + exteriorHeight) * 2) + 10;
    } else if (s === 'round') {
        const dia = parseFloat(d.diameter || 0);
        // PHP: ((diameter * pi) * 2) * 1.2 — doubled for two faces, 20% extra
        return (Math.PI * dia * 2) * 1.2;
    }
    return 0;
}


/**
 * Build a list of cushion items (seats/backs) based on the selected product type.
 *
 * This function parses the product "Part" selection label text (e.g.,
 * "2 Backs / 1 Seat", "3 Seats", "Ottoman", "L-Shape") and produces a
 * normalized array of items to drive downstream calculations. Each item
 * includes its type, its index within that type group, the total count for
 * that type, the detected shape, and an initially empty dimensions object.
 *
 * Example return value:
 * [
 *   { type: 'seat', itemInCount: 1, typeCount: 2, name: 'seat_1', shape: 'square_rectangle', dimensions: {} },
 *   { type: 'seat', itemInCount: 2, typeCount: 2, name: 'seat_2', shape: 'square_rectangle', dimensions: {} },
 *   { type: 'back', itemInCount: 1, typeCount: 1, name: 'back_1', shape: 'square_rectangle', dimensions: {} },
 * ]
 *
 * Notes:
 * - "L-Shape" maps to 2 seats.
 * - "Ottoman" maps to 1 seat.
 * - When only a generic word like "Seat" or "Back" is present, a single
 *   instance is assumed.
 *
 * @returns {Array<{type:'seat'|'back',itemInCount:number,typeCount:number,name:string,shape:string,dimensions:Object}>}
 */
function getCushionItems() {
    /* 
    When our inputProductType contains references to seat, back, breaks and sections ( chaise sections which are treated like seats ), 
    or L-Shape ( which is 2 seats ), Ottoman ( which is 1 seat ), we need to get the appropriate number of items as 
    separate elements in an object like
    {
        {type: seat, typeCount: 1, name: seat_1, shape: "square_rectangle", dimensions: {}, fabrication: {}},
        {type: back, typeCount: 1, name: back_1, shape: "square_rectangle", dimensions: {}, fabrication: {}}
    }

    These are real values we have to account for
    Seat and Back
    Seat
    Back
    Ottoman 
    1 Breaks, 2 Sections
    2 Breaks, 3 Sections
    3 Breaks, 4 Sections
    1 Seat
    2 Seats
    3 Seats
    1 Back / 1 Seat
    2 Backs / 1 Seat
    2 Backs / 2 Seat
    3 Backs / 1 Seat
    3 Backs / 3 Seats
    L-Shape
    */
    let shape = getCushionShape();
    // Get quantity
    let inputProductQuantityValue = $q("quantity-input .qty-input__input.input").val();
    // Read selected product type label text
    let inputProductType = $q('._cd--product-type input[type="radio"]:checked').next('label.label').find('span').text().trim();

    // Normalize for parsing
    let label = (inputProductType || "").toLowerCase();
    //console.log('label is ' + label);
    // Defaults
    let seatCount = 0;
    let backCount = 0;

    // Helper to safely parse first integer from a match group
    function toInt(v) {
        let n = parseInt(v, 10);
        return Number.isFinite(n) ? n : 0;
    }

    // Pattern: "X backs / Y seats"
    let backsSeats = label.match(/(\d+)\s*backs?\s*\/\s*(\d+)\s*seats?/);
    if (backsSeats) {
        backCount = toInt(backsSeats[1]);
        seatCount = toInt(backsSeats[2]);
    } else {
        // Pattern: "X seats"
        let seatsOnly = label.match(/(\d+)\s*seats?/);
        if (seatsOnly) {
            seatCount = toInt(seatsOnly[1]);
        }

        // Pattern: "X backs"
        let backsOnly = label.match(/(\d+)\s*backs?/);
        if (backsOnly) {
            backCount = toInt(backsOnly[1]);
        }
    }

    // Specific named configurations
    if (label.includes('seat and back')) {
        seatCount = Math.max(seatCount, 1);
        backCount = Math.max(backCount, 1);
    }
    if (label.includes('bed and headrest')) {
        seatCount = Math.max(seatCount, 1);
        backCount = Math.max(backCount, 1);        
    }
    if (label.includes('l-shape')) {
        // L-Shape corresponds to 2 seats
        seatCount = Math.max(seatCount, 2);
    }
    if (label.includes('ottoman')) {
        // Ottoman corresponds to 1 seat
        seatCount = Math.max(seatCount, 1);
    }
    if (label.includes('bed')) {
        // Bed corresponds  to 1 seat
        seatCount = Math.max(seatCount, 1);
    }



    // Breaks/Sections (chaise sections) handling
    let chaiseBreaks = label.match(/(\d+)\s*breaks?/i);
    let chaiseSections = label.match(/(\d+)\s*sections?/i);
    
    if (chaiseBreaks && chaiseSections) {
        let numSections = toInt(chaiseSections[1]);
        // First section is a back, subsequent sections are seats
        if (numSections >= 1) {
            backCount = Math.max(backCount, 1); // First section as back
            seatCount = Math.max(seatCount, numSections - 1); // Remaining as seats
        }
    }

    // Fallbacks if label is generic "seat" or "back"
    if (seatCount === 0 && label === 'seat') { seatCount = 1; }
    if (backCount === 0 && label === 'back') { backCount = 1; }
    // Fallbacks if label is generic "bed" or "headrest"
    if (seatCount === 0 && label === 'bed') { seatCount = 1; }
    if (backCount === 0 && label === 'headrest') { backCount = 1; }

    // Build items
    let items = [];
    for (let i = 1; i <= seatCount; i++) {
        items.push({ type: 'seat', itemInCount: i, typeCount: seatCount, name: 'seat_' + i, shape: shape, dimensions: {}, fabrication: {} });
    }
    for (let i = 1; i <= backCount; i++) {
        items.push({ type: 'back', itemInCount: i, typeCount: backCount, name: 'back_' + i, shape: shape, dimensions: {}, fabrication: {} });
    }

    return items;
}

/**
 * Read and normalize dimensions for a Seat with square/rectangle shape.
 *
 * For multi-seat configurations, the input width represents the total span;
 * this function divides the width by inputTypeCount to get the per-seat width.
 * Handles special builders (e.g., Chaise, Breakfast Nook) which use different
 * field sets for width/depth.
 *
 * Expected fields read (depending on builder type):
 * - Seat/Back width
 * - Seat depth (or section depth)
 * - Seat/Back thickness
 *
 * Returns an empty object when inputs are incomplete.
 *
 * @param {number} inputTypeCount Total number of seats for this configuration
 * @returns {{width:number, depth:number, thickness:number}|{}} Per-seat dimensions or {}
 */
function getSeatSquareRectangleDimensions(inputTypeCount, itemInCount) {
    
    let dimensions = {};

    if (isChaiseBuilder){
        // Chaise sections: use backWidthField for width, seatDepthNField for depth, backThicknessField for thickness
        // itemInCount indicates which section (1, 2, 3, 4)

        // Use backWidthField for all sections
        let width = self.checkDimensionValue($q('._cd--back-width input').val());

        // Use seatDepthNField based on section number (itemInCount + 1 since first section is back)
        let sectionNum = itemInCount + 1; // Seat sections are 2, 3, 4...
        let selectorDepth = "._cd--seat-depth-" + sectionNum;
        let depth = self.checkDimensionValue($q(selectorDepth + " input").val());

        // Use backThicknessField for all sections
        let thickness = self.checkDimensionValue($q('._cd--back-thickness select option:checked').text());
    
        if (width && depth && thickness) {        
            dimensions.width = width; // Don't divide by inputTypeCount for chaise sections
            dimensions.depth = depth;
            dimensions.thickness = thickness;
        }
    } else if (isBreakfastNookBuilder){
        // Breakfast Nook is odd in that it has a seat width 1, seat depth 1, seat width 2, and seat depth 2 dimensions

        // size seat width - input - square rectangle
        // Breakfast Nook has per-seat width fields (seat-width-1, seat-width-2), so use itemInCount
        let width = self.checkDimensionValue($q("._cd--seat-width-" + itemInCount + " input").val());

        // size seat depth - input - square rectangle or trapezoid
        // Breakfast Nook has per-seat depth fields (seat-depth-1, seat-depth-2), so use itemInCount
        let depth = self.checkDimensionValue($q("._cd--seat-depth-" + itemInCount + " input").val());

        // size seat thickness - input - shape agnostic
        let thickness = self.checkDimensionValue($q('._cd--seat-thickness select option:checked').text());        

        if (width && depth && thickness) {        
            dimensions.width = width; // No division needed - each seat has its own width field
            dimensions.depth = depth;
            dimensions.thickness = thickness;
        }
    } else {        
    
        // size seat width - input - square rectangle
        let width = self.checkDimensionValue($q('._cd--seat-width input').val());

        // size seat depth - input - square rectangle or trapezoid
        let depth = self.checkDimensionValue($q('._cd--seat-depth input').val());

        // size seat thickness - input - shape agnostic
        let thickness = self.checkDimensionValue($q('._cd--seat-thickness select option:checked').text());        

        if (width && depth && thickness) {        
            dimensions.width = (width / inputTypeCount);
            dimensions.depth = depth;
            dimensions.thickness = thickness;
        }
    }

    return dimensions;
}

/**
 * Read and normalize dimensions for a Back with square/rectangle shape.
 *
 * For multi-back configurations, the input width represents the total span;
 * this function divides the width by inputTypeCount to get the per-back width.
 * In loveseat/sofa builders, the back width is sourced from the seat width per
 * legacy UI conventions.
 *
 * Expected fields read:
 * - Back width (or seat width for loveseat/sofa)
 * - Back height
 * - Back thickness
 *
 * Returns an empty object when inputs are incomplete.
 *
 * @param {number} inputTypeCount Total number of backs for this configuration
 * @returns {{width:number, height:number, thickness:number}|{}} Per-back dimensions or {}
 */
function getBackSquareRectangleDimensions(inputTypeCount, itemInCount) {

    let width;
    // size width - input - square rectangle
    if (isLoveseatBuilder || isSofaBuilder) {
        width = self.checkDimensionValue($q('._cd--seat-width input').val());
    } else if (isChaiseBuilder) {
        // For chaise back (first section), use backWidthField
        width = self.checkDimensionValue($q('._cd--back-width input').val());
    } else {
        width = self.checkDimensionValue($q('._cd--back-width input').val());
    }

    let height, thickness;
    
    if (isChaiseBuilder) {
        // For chaise back (first section), use seatDepth1Field as height and backThicknessField
        height = self.checkDimensionValue($q('._cd--seat-depth-1 input').val());
        thickness = self.checkDimensionValue($q('._cd--back-thickness select option:checked').text());
    } else {
        // size back height - input - square rectangle or trapezoid
        height = self.checkDimensionValue($q('._cd--back-height input').val());
        // size back thickness - input - shape agnostic
        thickness = self.checkDimensionValue($q('._cd--back-thickness select option:checked').text());
    }
    
    let dimensions = {};

    if (width && height && thickness) {        
        dimensions.width = isChaiseBuilder ? width : (width / inputTypeCount); // Don't divide for chaise
        dimensions.height = height;
        dimensions.thickness = thickness;
    }

    return dimensions;
}

/**
 * Read and normalize dimensions for a Seat with trapezoid shape.
 *
 * For multi-seat configurations, both front and rear widths are divided by
 * inputTypeCount to obtain per-seat widths. Depth and thickness are shared.
 *
 * Expected fields read:
 * - Seat front width
 * - Seat rear width
 * - Seat depth
 * - Seat thickness
 *
 * Returns an empty object when inputs are incomplete.
 *
 * @param {number} inputTypeCount Total number of seats for this configuration
 * @returns {{frontWidth:number,rearWidth:number,depth:number,thickness:number}|{}}
 */
function getSeatTrapezoidDimensions(inputTypeCount, itemInCount) {

    // size seat front width - input - trapezoid
    let frontWidth = self.checkDimensionValue($q('._cd--seat-front-width input').val());

    // size seat rear width - input - trapezoid
    let rearWidth = self.checkDimensionValue($q('._cd--seat-rear-width input').val());

    // size seat depth - input - sqaure rectangle or trapezoid
    let depth = self.checkDimensionValue($q('._cd--seat-depth input').val());

    // size seat thickness - input - shape agnostic
    let thickness = self.checkDimensionValue($q('._cd--seat-thickness select option:checked').text());

    let dimensions = {};

    if (frontWidth && rearWidth && depth && thickness) {        
        dimensions.frontWidth = (frontWidth / inputTypeCount);
        dimensions.rearWidth = (rearWidth / inputTypeCount);
        dimensions.depth = depth;
        dimensions.thickness = thickness;
    }
    //console.log(dimensions);

    return dimensions;    
}

/**
 * Read and normalize dimensions for a Back with trapezoid shape.
 *
 * For multi-back configurations, both upper and lower widths are divided by
 * inputTypeCount to obtain per-back widths. Height and thickness are shared.
 *
 * Expected fields read:
 * - Back upper width
 * - Back lower width
 * - Back height
 * - Back thickness
 *
 * Returns an empty object when inputs are incomplete.
 *
 * @param {number} inputTypeCount Total number of backs for this configuration
 * @returns {{upperWidth:number,lowerWidth:number,height:number,thickness:number}|{}}
 */
function getBackTrapezoidDimensions(inputTypeCount, itemInCount) {

    // size back upper width - input - trapezoid
    let upperWidth = self.checkDimensionValue($q('._cd--back-upper-width input').val());

    // size back lower width - input - trapezoid
    let lowerWidth = self.checkDimensionValue($q('._cd--back-lower-width input').val());

    // size back height - input - sqaure rectangle or trapezoid
    let height = self.checkDimensionValue($q('._cd--back-height input').val());

    // size back thickness - input - shape agnostic
    let thickness = self.checkDimensionValue($q('._cd--back-thickness select option:checked').text());
        
    let dimensions = {};

    if (upperWidth && lowerWidth && height && thickness) {        
        dimensions.upperWidth = (upperWidth / inputTypeCount);
        dimensions.lowerWidth = (lowerWidth / inputTypeCount);
        dimensions.height = height;
        dimensions.thickness = thickness;
    }

    return dimensions;
}

/**
 * Read dimensions for a Seat with round shape.
 *
 * NOTE: Only seats can be round shaped. Backs are always square_rectangle or trapezoid.
 * There is intentionally no getBackRoundDimensions function.
 *
 * Expected fields read:
 * - Seat diameter
 * - Seat thickness
 *
 * Returns an empty object when inputs are incomplete.
 *
 * @returns {{diameter:number, thickness:number}|{}}
 */
function getSeatRoundDimensions(inputTypeCount, itemInCount) {

    // size diameter - input - round
    let diameter = self.checkDimensionValue($q('._cd--seat-diameter input').val());

    // size seat thickness - input - shape agnostic
    let thickness = self.checkDimensionValue($q('._cd--seat-thickness select option:checked').text());

    let dimensions = {};    

    if (diameter && thickness) {        
        dimensions.diameter = diameter;
        dimensions.thickness = thickness;
    }

    return dimensions;    
}

/**
 * Validate and normalize a numeric dimension input value.
 *
 * Behavior:
 * - For standard numeric fields, accepts non-empty, non-zero numeric strings
 *   and returns the parsed number; otherwise returns an empty string.
 * - For thickness fields, also rejects the placeholder "-- inches --" value.
 *
 * This helper both validates and converts the value so that callers can use
 * truthy checks and directly consume the numeric output.
 *
 * @param {string} inputValue Raw value from input/select
 * @param {boolean} [inputIsThicknessValue=false] Whether the field is a thickness selector
 * @returns {number|''} Parsed number on success; empty string when invalid
 */
function checkDimensionValue(inputValue, inputIsThicknessValue = false) {

    let passedCheck = false;
    let output = '';
    let trimmedValue = (inputValue || '').trim();
    let parsedValue = parseFloat(trimmedValue);

    if (inputIsThicknessValue === false) {
        passedCheck = (trimmedValue !== "" && !isNaN(parsedValue) && parsedValue !== 0);
        output = passedCheck ? parsedValue : '';
    } else {
        passedCheck = (trimmedValue !== "-- inches --" && !isNaN(parsedValue) && parsedValue !== 0);
        output = passedCheck ? parsedValue : '';
    }

    return output;
}

/**
 * Populate each item with its dimensions by dispatching to the appropriate
 * shape-specific reader.
 *
 * Constructs a method name from the item type and shape, such as:
 * - getSeatSquareRectangleDimensions
 * - getBackSquareRectangleDimensions
 * - getSeatTrapezoidDimensions
 * - getBackTrapezoidDimensions
 * - getSeatRoundDimensions
 *
 * Note: getBackRoundDimensions does not exist because backs cannot be round shaped.
 * Only seats support the round shape. Backs are always square_rectangle or trapezoid.
 *
 * Each reader is invoked with the item.typeCount to support width splitting
 * across multiple components.
 *
 * @param {Array<Object>} items Items produced by getCushionItems()
 * @returns {Array<Object>} Same array with dimensions populated where possible
 */
function getDimensions(items) {

    // Iterate through items object
    
    for (let i = 0; i < items.length; i++) {
        let item = items[i];
        let typeCount = item.typeCount;

        // Build method name
        let methodName = "get" + item.type.charAt(0).toUpperCase() + item.type.slice(1) + item.shape.replace("_", " ").replace(/\b\w/g, c => c.toUpperCase()).replace(" ", "") + "Dimensions";
        let method = this[methodName];

        //console.log('method name is ' + methodName);

        if (typeof method === 'function') {
            item.dimensions = method(typeCount, item.itemInCount);
            items[i] = item;
        } //else {
            //if(window.console){ console.error("Method " + methodName + " not found"); }
        //}
    }

    //console.log('item diemnsions are')
    //console.log(items);

    return items;
}

/**
 * Verify that every item has a non-empty dimensions object.
 *
 * Useful for short-circuiting downstream yardage calculation until all
 * required inputs are provided.
 *
 * @param {Array<Object>} items Items with dimensions
 * @returns {boolean} True when all items have non-empty dimensions; otherwise false
 */
function getAllItemsPassedDimensionsCheck(items) {
    let output = false;

    // Set dimensionsCheck true only if all items' dimensions objects are not empty
    output = Array.isArray(items) && items.length > 0 && items.every(function(it){
        return it && it.dimensions && Object.keys(it.dimensions).length > 0;
    });
    
    return output;
}   

/**
 * Local manufacturing constants (non-RAIN)
 * Values validated against builderManufacturing.php configuration.
 *
 * Oversized face handling (faces wider than fabric bolt width):
 * Standard upholstery practice is to first attempt railroading — rotating the
 * face 90° so the shorter dimension spans the bolt width. This works for
 * non-directional fabrics. If neither dimension fits, the face is cut from
 * multiple widths of fabric and seamed together. Yardage for seamed faces is
 * calculated as ceil(faceWidth / fabricWidth) * faceHeight linear inches.
 * See tessellateFaces() for implementation.
 */
const CONFIG = {
    edgeAllowance: 0.5,                 // 0.5" per edge; effectively +2" total on three-side runs
    spacingBetweenPatterns: 0.5,        // reserved for future packing kerf/spacing
    fBoxingNotchWidth: 2.0,             // reserved; if we model notches during packing
    zBoxingLargeWidthMarkup: 4,         // add across cushion width for zipper side (large)
    zBoxingSmallWidthMarkup: 4,         // add across cushion width for zipper side (small)
    zBoxingLargeHeightMarkup: 1,        // add to thickness/2 for large zipper strip
    zBoxingSmallHeightMarkup: 0.5,      // add to thickness/2 for small zipper strip
    // Manufacturing config alignment
    widthAdjustmentThreshold: 40,       // inches
    widthAdjustmentPercent: 0.005,      // non-waterproof
    widthAdjustmentPercentIsWaterproof: 0.01, // waterproof
    roundingRadiusInches: 2.5,
    arcRadius: 1.963,
    waterproofArcRadius: 1.178,
    weltStripCutWidth: 1.75             // align to PHP weltStripHeight 1.75
};

/**
 * Derive a rectangular face footprint from an item's dimensions.
 * - square_rectangle seat: width = seat.width, length = seat.depth
 * - square_rectangle back: width = back.width, length = back.height
 * - trapezoid seat: width = max(frontWidth,rearWidth), length = depth
 * - trapezoid back: width = max(upperWidth,lowerWidth), length = height
 * - round seat: width = length = diameter
 *
 * @param {{type:string,shape:string,dimensions:Object}} item
 * @returns {{width:number,length:number,thickness:number,shape:string}}
 */
function getItemFaceRect(item) {
    const shape = item.shape;
    const d = item.dimensions || {};
    let width = 0;
    let length = 0;
    let thickness = 0;

    if (shape === 'square_rectangle') {
        if (item.type === 'seat') {
            width = parseFloat(d.width || 0);
            length = parseFloat(d.depth || 0);
        } else {
            width = parseFloat(d.width || 0);
            length = parseFloat(d.height || 0);
        }
        thickness = parseFloat(d.thickness || 0);
    } else if (shape === 'trapezoid') {
        if (item.type === 'seat') {
            const f = parseFloat(d.frontWidth || 0);
            const r = parseFloat(d.rearWidth || 0);
            width = Math.max(f, r);
            length = parseFloat(d.depth || 0);
        } else {
            const u = parseFloat(d.upperWidth || 0);
            const l = parseFloat(d.lowerWidth || 0);
            width = Math.max(u, l);
            length = parseFloat(d.height || 0);
        }
        thickness = parseFloat(d.thickness || 0);
    } else if (shape === 'round') {
        const dia = parseFloat(d.diameter || 0);
        width = dia;
        length = dia;
        thickness = parseFloat(d.thickness || 0);
    }

    return { width, length, thickness, shape };
}

/**
 * Width-based adjustment used by manufacturing for zipper and transitions.
 *
 * NOTE: This is a partial approximation for waterproof (Sunbrella Rain) fabrics.
 * Waterproof cushions are constructed differently from standard cushions (different
 * seam placement, no welt, different zipper configuration, waterproof-specific
 * tessellation constraints). For true fabric yardage estimates on waterproof cushions,
 * dedicated construction methods and tessellation logic would need to be implemented
 * rather than simply applying a different width adjustment percentage.
 *
 * @param {number} width
 * @param {boolean} isWaterproof
 * @returns {number}
 */
function computeWidthAdjustment(width, isWaterproof=false){
    const w = parseFloat(width||0);
    if (w <= 0) return 0;
    const pct = isWaterproof ? CONFIG.widthAdjustmentPercentIsWaterproof : CONFIG.widthAdjustmentPercent;
    if (w >= CONFIG.widthAdjustmentThreshold) return w * pct; // e.g., 59 * 0.005 = 0.295
    return 0.0;
}

/**
 * For square/rectangle seats: zipper run length across width with markup and width-based adjustment.
 * Falls back to face width for other shapes (we only use this exact formula for square/rectangle seats).
 * @param {Object} item
 * @param {boolean} isWaterproof
 * @param {number} widthMarkup - The width markup to add (zBoxingLargeWidthMarkup or zBoxingSmallWidthMarkup)
 * @returns {number}
 */
function computeZipperBaseWidth(item, isWaterproof=false, widthMarkup=CONFIG.zBoxingLargeWidthMarkup){
    const s = item.shape;
    const d = item.dimensions || {};
    if (s === 'square_rectangle' && item.type === 'seat'){
        let w = parseFloat(d.width||0);
        // Width adjustment only when >= threshold
        const wAdj = computeWidthAdjustment(w, isWaterproof);
        w += wAdj;
        // Optional corner rounding for Top when corners provided
        if (Array.isArray(item.corners) && item.corners.includes('Top')) {
            w -= (1.144 * 2);
        }
        return w + widthMarkup;
    }
    // default
    const face = getItemFaceRect(item);
    let w = face.width || 0;
    w += computeWidthAdjustment(w, isWaterproof);
    return w + widthMarkup;
}

/**
 * Compute linear boxing inches for a cushion/back (FBoxing — three sides).
 * The fourth side is covered by the zipper boxing (ZBoxing).
 *
 * Formulas match builderManufacturing.php FBoxing generation:
 * - square_rectangle: width + 2*(length - 2)  [seam allowance -2" per side]
 * - trapezoid: upperWidth + (height - 1) + (exteriorHeight - 1)  [seam allowance -1" per side]
 * - round: (diameter * pi / 3) * 2  [2/3 of circumference; remaining 1/3 is zipper section]
 *
 * No separate edge allowance is added — seam allowances are built into each formula
 *
 * @param {{type:string,shape:string,dimensions:Object}} item
 * @param {number} edgeAllowance  (unused — kept for API compatibility)
 * @param {boolean} isWaterproof
 * @returns {number}
 */
function computeBoxingLinearByShape(item, edgeAllowance, isWaterproof=false) {
    const s = item.shape;
    const d = item.dimensions || {};

    if (s === 'square_rectangle') {
        if ((item.type === 'seat') || (item.type === 'back')) {
            let w = parseFloat(d.width || 0);

            /* Need l to use d.height when item.type is back */
            let l = 0;

            if (item.type === 'seat') {
                l = parseFloat(d.depth || 0);
            } else if (item.type === 'back') {
                l = parseFloat(d.height || 0);
            }

            // Apply width adjustment rule (matches PHP dimension parsing)
            w += computeWidthAdjustment(w, isWaterproof);
            // FBoxing: w + 2*(l - 2) — seam allowance -2" per side, no edge allowance
            let fWidth = w + (2 * (l - 2));
            // Corner rounding subtraction for Bottom if provided
            if (Array.isArray(item.corners) && item.corners.includes('Bottom')) {
                fWidth -= (1.144 * 2);
            }
            return fWidth;
        }
    } else if (s === 'trapezoid') {
        // PHP maps: seat frontWidth→upperWidth, rearWidth→lowerWidth, depth→height
        //           back upperWidth→upperWidth, lowerWidth→lowerWidth, height→height
        let upperW, lowerW, height;
        if (item.type === 'seat') {
            upperW = parseFloat(d.frontWidth || 0);
            lowerW = parseFloat(d.rearWidth || 0);
            height = parseFloat(d.depth || 0);
        } else {
            upperW = parseFloat(d.upperWidth || 0);
            lowerW = parseFloat(d.lowerWidth || 0);
            height = parseFloat(d.height || 0);
        }

        // Apply width adjustment to both widths (matches PHP dimension parsing)
        upperW += computeWidthAdjustment(upperW, isWaterproof);
        lowerW += computeWidthAdjustment(lowerW, isWaterproof);

        // Compute exteriorHeight (slant height) when widths differ
        // PHP: sqrt(height^2 + (upperWidth - lowerWidth)^2)
        // PHP only uses slant height when instances > 1; for single instances uses regular height.
        // We use slant height whenever widths differ for conservative yardage estimation.
        let exteriorHeight = height;
        if (upperW !== lowerW) {
            exteriorHeight = Math.sqrt(Math.pow(height, 2) + Math.pow(Math.abs(upperW - lowerW), 2));
        }

        // FBoxing: upperWidth + (height - 1) + (exteriorHeight - 1)
        // Seam allowance -1" per side, no edge allowance
        // Only upperWidth (front/top) is included — lowerWidth (rear/bottom) is the zipper side
        return upperW + (height - 1) + (exteriorHeight - 1);
    } else if (s === 'round') {
        let dia = parseFloat(d.diameter || 0);
        // Apply width adjustment to diameter (matches PHP dimension parsing for round)
        dia += computeWidthAdjustment(dia, isWaterproof);
        // FBoxing: 2/3 of circumference — remaining 1/3 is the zipper section
        // No edge allowance
        return (Math.PI * dia * 2) / 3;
    }
    return 0;
}

/**
 * Given thickness, return zipper-large and zipper-small strip heights.
 * @param {number} thickness
 * @returns {{large:number,small:number}}
 */
function computeZipperHeights(thickness) {
    const t = parseFloat(thickness || 0);
    return {
        large: (t / 2) + CONFIG.zBoxingLargeHeightMarkup,
        small: (t / 2) + CONFIG.zBoxingSmallHeightMarkup
    };
}

/**
 * Build fabrication pieces for a single item and attach to item.fabrication.
 * Pieces:
 * - FaceTop {width,length}
 * - FaceBottom {width,length}
 * - Boxing {stripHeight,linearInches}
 * - ZBoxingLarge {stripHeight,linearInches}
 * - ZBoxingSmall {stripHeight,linearInches}
 *
 * @param {{type:string,shape:string,dimensions:Object,fabrication?:Object}} item
 * @param {{edgeAllowance:number}} cfg
 * @returns {{type:string,shape:string,dimensions:Object,fabrication:Object}}
 */
function buildFabricationForItem(item, cfg) {
    const edgeAllowance = (cfg && typeof cfg.edgeAllowance === 'number') ? cfg.edgeAllowance : CONFIG.edgeAllowance;

    // Guard: missing dims
    if (!item || !item.dimensions || Object.keys(item.dimensions).length === 0) {
        item.fabrication = {};
        return item;
    }

    const face = getItemFaceRect(item);
    const thickness = face.thickness;

    if (!(face.width && face.length && thickness)) {
        item.fabrication = {};
        return item;
    }

    const isWaterproof = !!(cfg && cfg.isWaterproof);

    const boxingStripHeight = thickness; // PHP uses thickness as strip height
    const boxingLinear = computeBoxingLinearByShape(item, edgeAllowance, isWaterproof);

    // Zipper pieces: base width across cushion width with respective markups, optional corner rounding on Top
    // Applies zBoxingLargeWidthMarkup for large and zBoxingSmallWidthMarkup for small independently
    // For round shapes, apply width adjustment to diameter (matches PHP dimension parsing)
    const roundBaseW = (face.shape === 'round') ? (face.width + computeWidthAdjustment(face.width, isWaterproof)) : 0;
    const zBaseWidthLarge = (face.shape === 'round') ? roundBaseW : computeZipperBaseWidth(item, isWaterproof, CONFIG.zBoxingLargeWidthMarkup);
    const zBaseWidthSmall = (face.shape === 'round') ? roundBaseW : computeZipperBaseWidth(item, isWaterproof, CONFIG.zBoxingSmallWidthMarkup);
    const zHeights = computeZipperHeights(thickness);

    // Fabric names
    const fabricName = cfg && cfg.fabricName ? String(cfg.fabricName) : '';
    const weltFabricName = cfg && cfg.weltFabricName ? String(cfg.weltFabricName) : '';
    const weltEnabled = !!(cfg && cfg.weltEnabled);
    const qty = Math.max(0, parseInt((cfg && cfg.quantity) ? cfg.quantity : 0, 10));

    const facePolygon = buildFacePolygon(item);
    // Face sizes: mirror PHP dimension adjustment only (width threshold percent). No extra +0.5 SOP.
    let faceWidthAdj = 0;
    let faceLengthAdj = 0;
    if (((item.type === 'seat') || (item.type === 'back')) && face.shape === 'square_rectangle'){
        const baseW = face.width;
        faceWidthAdj = computeWidthAdjustment(baseW, isWaterproof);
        faceLengthAdj = 0; // PHP does not auto-add to length for faces
    } else if (((item.type === 'seat') || (item.type === 'back')) && face.shape === 'trapezoid'){
        // PHP applies width adjustment to both upperWidth and lowerWidth during dimension parsing
        faceWidthAdj = computeWidthAdjustment(face.width, isWaterproof);
        faceLengthAdj = 0;
    } else if (((item.type === 'seat') || (item.type === 'back')) && face.shape === 'round'){
        // PHP applies width adjustment to diameter (stored as width) during dimension parsing
        faceWidthAdj = computeWidthAdjustment(face.width, isWaterproof);
        faceLengthAdj = computeWidthAdjustment(face.length, isWaterproof);
    }

    item.fabrication = {
        FaceTop: { name: 'FaceTop', width: face.width + faceWidthAdj, length: face.length + faceLengthAdj, fabricName: fabricName, quantity: qty, rotationAllowed: true, polygon: facePolygon },
        FaceBottom: { name: 'FaceBottom', width: face.width + faceWidthAdj, length: face.length + faceLengthAdj, fabricName: fabricName, quantity: qty, rotationAllowed: true, polygon: facePolygon },
        Boxing: { name: 'Boxing', stripHeight: boxingStripHeight, linearInches: boxingLinear, fabricName: fabricName, quantity: qty },
        ZBoxingLarge: { name: 'ZBoxingLarge', stripHeight: zHeights.large, linearInches: zBaseWidthLarge, fabricName: fabricName, quantity: qty },
        ZBoxingSmall: { name: 'ZBoxingSmall', stripHeight: zHeights.small, linearInches: zBaseWidthSmall, fabricName: fabricName, quantity: qty }
    };

    // Welt strips (optional; only if enabled)
    if (weltEnabled) {
        const perimeter = getItemPerimeter(item);
        item.fabrication.Welt = {
            name: 'Welt',
            stripHeight: CONFIG.weltStripCutWidth,
            linearInches: perimeter,
            fabricName: weltFabricName,
            quantity: qty
        };
    }

    return item;
}

/**
 * Attach fabrication pieces to every item.
 * @param {Array<Object>} items
 * @param {{edgeAllowance:number}} cfg
 * @returns {Array<Object>}
 */
function buildFabricationForItems(items, cfg) {
    if (!Array.isArray(items)) { return items; }
    for (let i = 0; i < items.length; i++) {
        items[i] = buildFabricationForItem(items[i], cfg);
    }
    return items;
}

/**
 * Build a packing preparation structure aggregating fabrication pieces across items.
 * Faces are rectangular panels; strips are linear cuts with a strip height.
 * This does not perform packing; it only prepares inputs for a bin packing step.
 *
 * faces: Array<{ width:number, length:number, count:number, name:string, source:string }>
 * strips: Array<{ name:string, stripHeight:number, totalLinear:number, count:number }>
 *
 * @param {Array<Object>} items Items with item.fabrication populated
 * @param {number} quantity Total product quantity
 * @returns {{faces:Array, strips:Array}}
 */
function buildPackingPreparation(items, quantity) {
    const faces = [];
    const strips = [];
    const q = Math.max(0, parseInt(quantity || 0, 10));
    if (!Array.isArray(items) || !q) { return { faces, strips }; }

    // Aggregate faces and strips
    for (let i = 0; i < items.length; i++) {
        const it = items[i];
        const f = it && it.fabrication ? it.fabrication : null;
        if (!f || !f.FaceTop || !f.FaceBottom || !f.Boxing || !f.ZBoxingLarge || !f.ZBoxingSmall) { continue; }

        const source_cushion = it.name;
        // Faces: two required per cushion per quantity - FaceTop and FaceBottom
        faces.push({ 
            name: 'FaceTop', 
            width: f.FaceTop.width, 
            length: f.FaceTop.length, 
            count: q, 
            source: source_cushion, 
            polygon: f.FaceTop.polygon, 
            rotationAllowed: !!f.FaceTop.rotationAllowed, 
            kerf: CONFIG.spacingBetweenPatterns, 
            fabricName: f.FaceTop.fabricName });
        faces.push({ 
            name: 'FaceBottom', 
            width: f.FaceBottom.width, 
            length: f.FaceBottom.length, 
            count: q, 
            source: source_cushion, 
            polygon: f.FaceBottom.polygon, 
            rotationAllowed: !!f.FaceBottom.rotationAllowed, 
            kerf: CONFIG.spacingBetweenPatterns, 
            fabricName: f.FaceBottom.fabricName });

        // Strips: 3 required per cushion per quantity - Boxing, ZBoxingLarge, and ZBoxingSmall 
        strips.push({ 
            name: 'Boxing', 
            width: f.Boxing.stripHeight,
            length: f.Boxing.linearInches,
            count: q, 
            source: source_cushion,
            polygon: {},
            rotationAllowed: !!f.Boxing.rotationAllowed,
            kerf: CONFIG.spacingBetweenPatterns,
            fabricName: f.Boxing.fabricName,            
            stripHeight: f.Boxing.stripHeight, 
            totalLinear: (f.Boxing.linearInches * q)});
        strips.push({ 
            name: 'ZBoxingLarge', 
            width: f.ZBoxingLarge.stripHeight,
            length: f.ZBoxingLarge.linearInches,
            count: q, 
            source: source_cushion,
            polygon: {},
            rotationAllowed: !!f.ZBoxingLarge.rotationAllowed,
            kerf: CONFIG.spacingBetweenPatterns,
            fabricName: f.ZBoxingLarge.fabricName,
            stripHeight: f.ZBoxingLarge.stripHeight, 
            totalLinear: (f.ZBoxingLarge.linearInches * q)});            
        strips.push({ 
            name: 'ZBoxingSmall',
            width: f.ZBoxingSmall.stripHeight,
            length: f.ZBoxingSmall.linearInches,
            count: q, 
            source: source_cushion,
            polygon: {},
            rotationAllowed: !!f.ZBoxingSmall.rotationAllowed,
            kerf: CONFIG.spacingBetweenPatterns,
            fabricName: f.ZBoxingSmall.fabricName,
            stripHeight: f.ZBoxingSmall.stripHeight, 
            totalLinear: (f.ZBoxingSmall.linearInches * q)});

        // Welt (optional)
        if (f.Welt && f.Welt.stripHeight && f.Welt.linearInches) {
            strips.push({ name: 'Welt', stripHeight: f.Welt.stripHeight, totalLinear: (f.Welt.linearInches * q), count: q, fabricName: f.Welt.fabricName });
        }
    }

    return { faces, strips };
}


/* 
// JTM - RS  
// product builder calc scripts - Cushion Builder
*/
/*
// global is builder type variables
isLoveseatBuilder
isSofaBuilder
isChairBuilder
isChaiseBuilder
isBarStoolBuilder
isDaybedBuilder
isOttomanBuilder
isGliderSwingBuilder
isFloorSeatingBuilder
*/

///////////////////////////////////////////////////////////
// calculate total fabric yards - Cushion Builder (all cushion builder types)
function calculateCushionFabricYardage() {
    /* Set output as an array */
    let output = false;
    let requiredYards = { main: { yardsRounded: 0 }, welt: { yardsRounded: 0 } };

    let calculationReadyState = false;

    let items = this.getCushionItems();

    items = this.getDimensions(items);
    //console.log(items);

    let dimensionsCheck = this.getAllItemsPassedDimensionsCheck(items);
    //console.log(dimensionsCheck);
    //if(window.console){console.log("calculateCushionFabricYardage triggered"); }

    ////////////////////////////////////////////////////////////
    // quantity - of product page

    let inputProductQuantityValue = $q("quantity-input .qty-input__input.input").val();

    ////////////////////////////////////////////////////////////
    // product type elements - part 

    let inputProductType = $q('._cd--product-type input[type="radio"]:checked').next('label.label').find('span').text().trim();
    
    let requiresYardageCheck = true;

    if ((inputProductType === "Foam Only") || (inputProductType === "Pillow Insert Only") || (inputProductType === "Bolster Pillow Insert Only")) {
        requiresYardageCheck = false;
    }

    if (requiresYardageCheck === false){
        output = [];
        output.push(0.00);
        output.push(0.00);

        return output;
    }  
    
    ////////////////////////////////////////////////////////////
    // fabric selection eelements
    let fabricSelection = this.getFabricSelection();

    ////////////////////////////////////////////////////////////
    // fabric elements
    // fabric name - sku
    let inputFabricNameValue = "";

    // fabric width - input
    let inputFabricWidthValue = 0.00;

    // fabric design - radio
    let inputFabricDesignValue = "";

    if ((fabricSelection === "standard") || (fabricSelection === "waterproof")) {
        inputFabricNameValue = $q("._cd--fabric-name-sku input.input-text").val();
        inputFabricWidthValue = $q("._cd--fabric-width input.input-text").val();
        inputFabricDesignValue = $q("._cd--fabric-design input.input-text").val();
    } else if (fabricSelection === "com") {
        inputFabricNameValue =  "COM: " + [
            $q('._cd--com-fabric-brand-name [data-cd-option-name="cd--com-fabric-brand-name"]').val(),
            $q('._cd--com-fabric-pattern-number [data-cd-option-name="cd--com-fabric-pattern-number"]').val(),
            $q('._cd--com-fabric-color-number [data-cd-option-name="cd--com-fabric-color-number"]').val()
        ].filter(Boolean).join(' ');
        inputFabricWidthValue = comFabricWidth;
        inputFabricDesignValue = comFabricDesign;
    }
                
    //console.log(inputFabricWidthValue);
   
    

    ////////////////////////////////////////////////////////////
    // welt fabric elements

    // welt inputs
    let inputWeltFabricNameValue = "";
    let inputWeltFabricWidthValue = "";
    let inputWeltFabricDesignValue = "";
    let weltCheck = false;
    
    if(document.querySelector('._cd--welt input[data-cd-option-name="cd--welt-double"]:checked') !== null){ 

        weltCheck = true;

        if ((fabricSelection === "standard") || (fabricSelection === "waterproof")) {
            // welt name - sku
            inputWeltFabricNameValue = $q("._cd--welt-name-sku input.input-text").val();
            // welt width - input
            inputWeltFabricWidthValue = $q("._cd--welt-width input.input-text").val();                        
            // welt design - input
            inputWeltFabricDesignValue = $q("._cd--welt-fabric-design input.input-text").val();
        } else if (fabricSelection === "com") {
            // welt com name - sku
            inputWeltFabricNameValue = "COM: " + [
                $q('._cd--com-welt-brand-name [data-cd-option-name="cd--com-welt-brand-name"]').val(),
                $q('._cd--com-welt-pattern-number [data-cd-option-name="cd--com-welt-pattern-number"]').val(),
                $q('._cd--com-welt-color-number [data-cd-option-name="cd--com-welt-color-number"]').val()
            ].filter(Boolean).join(' ');
            // welt com width - input
            inputWeltFabricWidthValue = comWeltFabricWidth;
            // welt com design - input
            inputWeltFabricDesignValue = comWeltFabricDesign;
        }
    }
    
    if (inputFabricDesignValue !== "" 
        && (dimensionsCheck === true) 
        && parseFloat(inputFabricWidthValue) !== 0 
        && inputProductQuantityValue !== "") 
    {
        calculationReadyState = true;
    }


    if(calculationReadyState == true){
        // Build fabrication pieces for each item (non-RAIN flow) with fabric names
        items = buildFabricationForItems(items, {
            edgeAllowance: CONFIG.edgeAllowance,
            fabricName: inputFabricNameValue,
            weltFabricName: inputWeltFabricNameValue,
            weltEnabled: weltCheck,
            isWaterproof: (fabricSelection === "waterproof"),
            quantity: inputProductQuantityValue
        });
        //console.log('=== FABRICATION PIECES (per item) ===');
        items.forEach(function(it){
            if (!it.fabrication) return;
            //console.log('\n[' + it.name + '] type=' + it.type + ' shape=' + it.shape + ' qty=' + inputProductQuantityValue);
            var f = it.fabrication;

            //if (f.FaceTop)    console.log('  FaceTop:       ' + f.FaceTop.width + '" x ' + f.FaceTop.length + '"  (fabric: ' + f.FaceTop.fabricName + ')');
            //if (f.FaceBottom) console.log('  FaceBottom:    ' + f.FaceBottom.width + '" x ' + f.FaceBottom.length + '"  (fabric: ' + f.FaceBottom.fabricName + ')');
            //if (f.Boxing)     console.log('  Boxing:        stripHeight=' + f.Boxing.stripHeight + '"  linear=' + f.Boxing.linearInches + '"  (fabric: ' + f.Boxing.fabricName + ')');
            //if (f.ZBoxingLarge)  console.log('  ZBoxingLarge:  stripHeight=' + f.ZBoxingLarge.stripHeight + '"  linear=' + f.ZBoxingLarge.linearInches + '"  (fabric: ' + f.ZBoxingLarge.fabricName + ')');
            //if (f.ZBoxingSmall)  console.log('  ZBoxingSmall:  stripHeight=' + f.ZBoxingSmall.stripHeight + '"  linear=' + f.ZBoxingSmall.linearInches + '"  (fabric: ' + f.ZBoxingSmall.fabricName + ')');
            //if (f.Welt)       console.log('  Welt:          stripHeight=' + f.Welt.stripHeight + '"  linear=' + f.Welt.linearInches + '"  (fabric: ' + f.Welt.fabricName + ')');
        });
        //console.log('=== END FABRICATION PIECES ===');

        // Tessellated totals (faces via tessellateFaces, strips via passes). This does not alter return yet.
        try {
            const mainWidthInches = parseFloat(inputFabricWidthValue || 0);
            const weltWidthInches = parseFloat(inputWeltFabricWidthValue || mainWidthInches || 0);
            const totals = computeTessellatedTotals(items, inputProductQuantityValue, mainWidthInches, weltWidthInches);
            const roundUp = function(val, inc){
                const v = parseFloat(val || 0), i = parseFloat(inc || 0.25);
                if (window && window.self && typeof window.self.roundUpToNearest === 'function') {
                    return window.self.roundUpToNearest(v, i);
                }
                return Math.ceil(v / i) * i;
            };
            const mainRounded = roundUp(totals.main.yards, 0.25);
            const weltRounded = roundUp(totals.welt.yards, 0.25);

            requiredYards = {
                main: { inches: totals.main.inches, yardsPrecise: totals.main.yards, yardsRounded: mainRounded },
                welt: { inches: totals.welt.inches, yardsPrecise: totals.welt.yards, yardsRounded: weltRounded },
                placementsCount: Array.isArray(totals.facesPlacements) ? totals.facesPlacements.length : 0
            };

            //console.log('requiredYards',requiredYards);

            output = [];
            /* Add requiredYards.main.yardsRounded to output */
            output.push(requiredYards.main.yardsRounded);
            /* Add requiredYards.welt.yardsRounded to output */
            output.push(requiredYards.welt.yardsRounded);
        } catch (e) {
            if(window.console){ console.error(e); }
        }
    }

    return output;
};